import * as React from 'react';
import classnames from 'classnames';
import { isNil } from 'lodash';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./character-count.i18n.json'));

type Props = {
  charLimit: number,
  charCount?: number,
  showCountOnly?: boolean,
  align?: 'left' | 'center' | 'right',
  size?: 'small' | 'normal' | 'large',
  highlightOnError?: boolean,
  labelOverride?: string
};

class CharacterCount extends React.PureComponent<Props> {
  static defaultProps = {
    charLimit: 150,
    align: 'left',
    size: 'normal'
  };

  render(): React.ReactNode {
    const {
      charCount,
      charLimit,
      showCountOnly,
      align,
      size,
      highlightOnError,
      labelOverride
    } = this.props;

    if (isNil(charCount)) {
      return null;
    }

    const charsRemaining = charLimit - charCount;

    const containerClasses = classnames({
      'character-count': true,
      'character-count--error': highlightOnError && charsRemaining < 0,
      [`character-count--align-${String(align)}`]: align,
      [`character-count--size-${String(size)}`]: size
    });

    return (
      <div className={containerClasses}>
        {
          !showCountOnly && (
            <div className="character-count__remaining-text">
              {labelOverride || __t('character_count.label_chars_remaining')}&nbsp;
            </div>
          )
        }
        <div className="character-count__remaining-value">
          {charsRemaining}/{charLimit}
        </div>
      </div>
    );
  }
}

export default CharacterCount;
